import {Store} from "vuex";
import {VueInterface} from "@/shared/interfaces/VueInterface";
import PDFCatalogueList from './PDFCataloqueList';
import {VNode} from "vue";


export const initialize = (Vue: VueInterface, store: Store<object>) => {
    document.querySelectorAll('.pdf-catalog-list').forEach((el: Element) => {
        const scopedSlots:Record<string, () => string> = {};
        const slotElements:NodeListOf<HTMLElement>  = el.querySelectorAll('[v-slot]');

        slotElements.forEach((slot: HTMLElement) => {
            const slotName = slot.getAttribute('v-slot');
            if(slotName === null) return;

            scopedSlots[slotName] = ()  => slot.innerHTML;
        });

        return new Vue({
            el,
            store,
            data: Object.assign({content: el.innerHTML}, (el as HTMLElement).dataset),
            render: h => h(PDFCatalogueList, {scopedSlots})
        });
    })
}

